var StatusPedidoEnum = {
    PEDIDO_REALIZADO: {
        enumName: 'PEDIDO_REALIZADO',                      
        name: 'Pedido Realizado'
    },
    PEDIDO_RECEBIDO_PELA_LOJA: {
        enumName: 'PEDIDO_RECEBIDO_PELA_LOJA',  
        name: 'Pedido Recebido Pela Loja'      
    },
    PEDIDO_CONFIRMADO: {
        enumName: 'PEDIDO_CONFIRMADO',  
        name: 'Pedido Confirmado'      
    },
    EM_SEPARACAO: {
        enumName: 'EM_SEPARACAO',  
        name: 'Em Separação'      
    },
    DOCUMENTO_FISCAL_EMITIDO: {
        enumName: 'DOCUMENTO_FISCAL_EMITIDO',  
        name: 'NF/CF Emitido'      
    },
    EM_TRANSPORTE: {
        enumName: 'EM_TRANSPORTE',  
        name: 'Em Transporte'      
    },
    PEDIDO_ENTREGUE: {
        enumName: 'PEDIDO_ENTREGUE',  
        name: 'Pedido Entregue'      
    },
    PEDIDO_CANCELADO: {
        enumName: 'PEDIDO_CANCELADO',  
        name: 'Pedido Cancelado'      
    },
    get(value) {        
        if(value === null)
            return StatusPedidoEnum.REALIZADO;

        var array = Object.values(StatusPedidoEnum);
        var statusPedidoEnumFound = {};

        array.forEach(element => {
            if(element.enumName === value) {
                statusPedidoEnumFound = element;      
                return ;          
            }            
        });   
        
        return statusPedidoEnumFound;
    },
    getOptions() {        
        var array = Object.values(StatusPedidoEnum);
        var statusPedidoEnumList = [];

        statusPedidoEnumList.push({
            status: undefined,
            valor: 0, 
            texto: 'Selecione',
            selected: true
        })

        array.forEach(element => {
            if((typeof element) === 'function') {
                return ;
            }            

            statusPedidoEnumList.push({
                status: element,
                valor: element.name, 
                texto: element.name,
                selected: false
            });            
        });   
        
        return statusPedidoEnumList;
    }
}

export default StatusPedidoEnum;